import OzonSeoAiPanel from '../../../../components/OzonSeoAiPanel';

export default OzonSeoAiPanel;
